import type { UserRegistrationEvent } from "../types";
const isEventTrackingEnabled = process.env.REACT_APP_EVENT_TRACKING === "enabled";
export const userLoginEvent = (mobile_number: string) => {
    if (!isEventTrackingEnabled) {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'user_login',
        number: mobile_number
    })

}

export const userRegisterationEvent = (userRegistrationEvent: UserRegistrationEvent) => {
    if (!isEventTrackingEnabled) {
        return;
    }
    const { name = "", number = "", email = "", code = "" } = userRegistrationEvent;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'user_signup',
        name,
        number,
        email,
        code
    })
}   

export const loginStartedEvent = (sourceUrl: string) => {
    if (!isEventTrackingEnabled) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "login_started",
        source_url: sourceUrl,
    });
};

export const sendOtpClickedEvent = (
  mobile_number: string,
  sourceUrl: string
) => {
  

  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "send_otp_clicked",
    number: mobile_number,
    source_url: sourceUrl,
  });
};